import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class PesticideInstructionService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<PesticideInstruction[]> => {
    return this.apiHttp.get<PesticideInstruction[]>("pesticideinstructions");
  };

  public get = (id: number): Observable<PesticideInstruction> => {
    return this.apiHttp.get<PesticideInstruction>(`pesticideinstructions/${id}`);
  };
}

export interface PesticideInstruction {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
  orderNumber: number;
  requiresNumberOfDays: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/pesticide-instruction.service.ts